<template>
  <CheckboxQmulus
    :model-value="showOnlyAvailableApps"
    :label="i18n.global.t(`${I18N_PREFIX}.showOnlyAvailableApps`)"
    :disabled="!customUserStorage.isCustomUserSettingsLoaded"
    :loading="customUserStorage.isCustomUserSettingsLoading"
    @update:model-value="onChange"
  />
</template>

<script setup lang="ts">
import {
  i18n,
} from '@i18n';
import CheckboxQmulus from '@qmulus/ui/components/checkbox-qmulus/checkbox-qmulus.vue';
import {
  computed,
} from 'vue';

import {
  DEFAULT_USER_SETTINGS, useCustomUserStorageStore,
} from '@/store/pinia/custom-user-storage.js';

const I18N_PREFIX = 'components/checkbox-show-available-apps/checkbox-show-available-apps';

const customUserStorage = useCustomUserStorageStore();

const showOnlyAvailableApps = computed(() => customUserStorage.customUserSettings?.showOnlyAvailableApps ?? DEFAULT_USER_SETTINGS.showOnlyAvailableApps);

function onChange(value: boolean) {
  customUserStorage.createOrUpdateCustomUserSettings({
    ...customUserStorage.customUserSettings!,
    showOnlyAvailableApps: value,
  });
}
</script>
